import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface NumberInputProps {
  label: string;
  value: string | number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  unit?: string;
  size?: "small" | "medium";
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  unit = "",
  size = "medium",
}) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (value === null || value === undefined) {
      setInputValue("");
    } else {
      setInputValue(value?.toString());
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;

    if (!/^[\d.]*$/.test(rawValue)) {
      return;
    }

    const dotCount = (rawValue.match(/\./g) || []).length;
    if (dotCount > 1) {
      return;
    }

    setInputValue(rawValue);

    if (rawValue === "" || rawValue === ".") {
      onChange(null);
    } else {
      const numericValue = parseFloat(rawValue);
      onChange(isNaN(numericValue) ? null : numericValue);
    }
  };

  return (
    <TextField
      label={label}
      value={inputValue}
      onChange={handleChange}
      disabled={disabled}
      fullWidth
      slotProps={{
        input: {
          endAdornment: unit ? (
            <InputAdornment position="end">{unit}</InputAdornment>
          ) : undefined,
        },
      }}
      size={size}
    />
  );
};

export default NumberInput;
